// extracted by mini-css-extract-plugin
export default {"menu":"UserMenu_menu__yX-RO","item":"UserMenu_item__6LRdh","itemActive":"UserMenu_itemActive__Kh7S3","btns":"UserMenu_btns__pugx0","btn":"UserMenu_btn__peHkg"};